import { UserStatus } from '~/api/gqlEnumsBe';
import Thumbnail from '~/components/dragon-scales/Thumbnail/Thumbnail';
import User from '~/components/Icons/User';
import { getUserThumbnail } from '~/utilities/user';

type Props = {
  className?: string;
  'data-cy'?: string;
  /** Size in pixels. */
  size?: number;
  /** The user object containing their picture's 'thumbnailURL' */
  user?: (Parameters<typeof getUserThumbnail>[0] & { status?: UserStatus }) | null | undefined;
};

/**
 * Displays a user's avatar image or a placeholder if no image is available.
 */
export default function UserAvatar(_props: Props) {
  const props = { ..._props };
  props.size ??= 32;

  const userPicture = props.user ? getUserThumbnail(props.user) : undefined;

  return (
    <div
      className={[
        'shrink-0 overflow-hidden rounded-full',
        props.user?.status === UserStatus.DEACTIVATED ? 'grayscale' : '',
        props.className,
      ].join(' ')}
      data-cy={props['data-cy']}
      style={{ height: props.size, width: props.size }}
    >
      {userPicture ? (
        <Thumbnail size={props.size} thumbnail={userPicture} />
      ) : (
        <UserAvatarPlaceholder size={props.size} />
      )}
    </div>
  );
}

const UserAvatarPlaceholder = (props: { size: number }) => (
  <div
    className="flex items-center justify-center rounded-full bg-[#D0D5D7] fill-[white] text-[32px]"
    data-cy="empty-thumbnail"
    style={{ height: props.size, width: props.size }}
  >
    <User />
  </div>
);
